import { useEffect } from 'react';

interface ChatbotWidgetProps {
  apiKey: string;
}

/**
 * ChatbotWidget - Embeds the SyncX chatbot by injecting embed.js script
 * 
 * Usage:
 * <ChatbotWidget apiKey="sk_live_xxx" />
 */
const ChatbotWidget: React.FC<ChatbotWidgetProps> = ({
  apiKey
}) => {
  useEffect(() => {
    // Check if script already exists
    if (document.getElementById('syncx-chatbot-script')) {
      return;
    }

    // Chatbot frontend URL (local dev: Vite runs on 5173, production: your CDN)
    const chatbotUrl = process.env.REACT_APP_CHATBOT_URL || 'http://localhost:5173/syncx_chatbot';

    // Create and inject the embed script
    const script = document.createElement('script');
    script.id = 'syncx-chatbot-script';
    script.src = `${chatbotUrl}/embed.js`;
    script.setAttribute('data-api-key', apiKey);
    script.setAttribute('data-base-url', chatbotUrl);
    script.async = true;

    document.body.appendChild(script);

    // Cleanup on unmount
    return () => {
      // Remove script
      const existingScript = document.getElementById('syncx-chatbot-script');
      if (existingScript) {
        existingScript.remove();
      }
      // Remove iframe
      const iframe = document.getElementById('syncx-chatbot-iframe');
      if (iframe) {
        iframe.remove();
      }
      // Remove styles
      const styles = document.getElementById('syncx-chatbot-styles');
      if (styles) {
        styles.remove();
      }
      // Reset initialization flag so it can be re-initialized
      (window as any).SYNCX_CHATBOT_INITIALIZED = false;
    };
  }, [apiKey]);

  // This component doesn't render anything - the script handles everything
  return null;
};

export default ChatbotWidget;